import React from "react";

interface AuthenticatorApp {
	name: string;
	logo: string;
}

// Public assets live in /public/img (served from the app root).
const APPS: AuthenticatorApp[] = [
	{ name: "Google Authenticator", logo: "/img/google_authenticator.svg" },
	{ name: "Microsoft Authenticator", logo: "/img/microsoft_authenticator.png" },
];

/**
 * Small helper panel shown beside the enrolment QR code: suggests authenticator
 * apps the user can scan it with. Purely informational.
 */
export const AuthenticatorAppsHint = () => {
	return (
		<div className="flex flex-col gap-3" data-testid="authenticator-apps-hint">
			<p className="font-roboto text-sm font-semibold text-gray-800">
				Don&apos;t have an authenticator app?
			</p>
			<p className="font-roboto text-xs text-gray-500">
				Install one of these free apps, then scan the QR code:
			</p>
			<ul className="flex flex-col gap-3">
				{APPS.map((app) => (
					<li key={app.name} className="flex items-center gap-3">
						<img
							src={app.logo}
							alt=""
							aria-hidden="true"
							className="h-8 w-8 shrink-0 object-contain"
						/>
						<span className="font-roboto text-sm text-gray-700">{app.name}</span>
					</li>
				))}
			</ul>
		</div>
	);
};
